export const rolesTxt = {
  CREATE_NEW_ROLE: "Create new role",
};
